/* @ngInject */
export const CountryFactory = (CountryState) => {
    return function Country() {

        this.id = null;
        this.name = null;
        this.state = new CountryState();
    };
};
